import React from 'react';
import Currency from '../Currency';

export interface IPurchaseSubtotalProps {
  name: string;
  amount: number;
}

/*tslint:disable-next-line:variable-name*/
const PurchaseSubtotal = ({ name, amount }: IPurchaseSubtotalProps) => (
  <div className="cost-data__row cost-data__aligned-row">
    <div className="cost-data__content-cell cost-data__content-row-number cost-data__content-row-number--hidden-counter" />
    <div className="cost-data__content-cell cost-data__content-name">{name}</div>
    <div className="cost-data__content-cell cost-data__content-amount cost-data__content-amount--text-content">
      <Currency value={amount} />
    </div>
    <div className="cost-data__content-cell cost-data__content-control" />
  </div>
);

export default PurchaseSubtotal;
